import React from "react";
import { QuestionProps } from "./Props";
import { Explanation } from "./Explanation";

export function ExperimentalExplanation(props: QuestionProps) {
  return <Explanation {...props} />;
}
